<template>
  <div class="content-8__controlbar">
    <div v-if="Object.keys(hmZongHeMappingList).length > 0" class="content-8__controlbar__item">
      <div class="c8-itemtitle">
        <span class="c8-itemtitle__text">今日双面/号码统计</span>
      </div>
      <table class="even-color">
        <thead>
          <tr>
            <th>
              <span>号码</span>
            </th>
            <template v-if="lotteryType === '11x5'">
              <th v-for="num in 11" :key="num">
                <span>{{ num }}</span>
              </th>
            </template>
            <template v-if="lotteryType === 'ssc'">
              <th v-for="num in 9" :key="num">
                <span>{{ num }}</span>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span>出现次数</span>
            </td>
            <td v-for="(hm, index) in hmList" :key="index">
              <span>{{ hm }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="even-color">
        <thead>
          <tr>
            <th rowspan="2">
              <span>球位</span>
            </th>
            <th v-for="hmZongHe in hmZongHeList" :key="hmZongHe.key" :colspan="hmZongHe.colSpan">
              <span>{{ hmZongHe.tableName }}</span>
            </th>
          </tr>
          <tr>
            <th v-for="(danShuangDaXiao, index) in danShuangDaXiaoList" :key="index">
              <span>{{ danShuangDaXiao.label }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span>出现次数</span>
            </td>
            <td v-for="(danShuangDaXiao, index) in danShuangDaXiaoList" :key="index">
              <span>{{ gethmRowData(danShuangDaXiao) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { fieldList } from '@/utils/steven/shungmiantonji-2'
import { getCpStatisticsByStatsType_web, getCPStatistics_web } from '@/api/desktop/statistic'
import get from 'lodash.get'
export default {
  name: 'Ssc11x5ShungMianTonJi',
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('ShungMianTonJi required key "lotteryCode"')
        return ''
      }
    },
    lotteryType: {
      type: String,
      required: true,
      default: () => {
        console.error('ShungMianTonJi required key "lotteryType"')
        return ''
      }
    }
  },
  data() {
    return {
      hmZongHeMappingList: [],
      danShuangDaXiaoList: [],
      hmList: []
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.init()
    this.getDXDSHistoryStatistics(this.lotteryCode)
    this.getCpStatistics(this.lotteryCode)
  },
  methods: {
    init() {
      for (let i = 0; i < this.hmZongHeList.length; i++) {
        let numList
        if (i === 0) {
          numList = JSON.parse(JSON.stringify(this.numList['zongHe']))
          numList.forEach(num => {
            num.hm = `all`
          })
        } else {
          numList = JSON.parse(JSON.stringify(this.numList['common']))
          numList.forEach(num => {
            num.hm = `hm${i}`
          })
        }
        this.danShuangDaXiaoList = this.danShuangDaXiaoList.concat(numList)
      }
    },
    async getDXDSHistoryStatistics(code) {
      const [data, error] = await getCpStatisticsByStatsType_web('todayDxdsStatistics', {
        code,
        days: 1,
        rules: 'hmDanShuang,hmDaXiao,zongHeDanShuang,zongHeDaXiao'
      })
      if (error) return
      this.hmZongHeMappingList = this.formatHmZonghe(data)
    },
    async getCpStatistics(code) {
      const [data, error] = await getCPStatistics_web(code, 'todayNumberStatistics')
      if (error) return

      if (this.lotteryType === '11x5') {
        for (let i = 1; i < 12; i++) {
          let count = 0
          for (let j = 1; j < 6; j++) {
            count += data[`hm${j}`]['appearCount'][`num${i}`]
          }
          this.hmList.push(count)
        }
      }

      if (this.lotteryType === 'ssc') {
        for (let i = 1; i < 10; i++) {
          let count = 0
          for (let j = 1; j < 6; j++) {
            count += data[`hm${j}`]['appearCount'][`num${i}`]
          }
          this.hmList.push(count)
        }
      }
    },
    formatHmZonghe(data) {
      return this.hmZongHeList.reduce((acc, hmZongHe) => {
        if (hmZongHe.key === 'all') {
          acc[hmZongHe.key] = this.numList['zongHe'].reduce((item, num) => {
            item[num.key] = get(data, `${hmZongHe.key}.${num.parentKey}.${num.key}`, 0)
            return item
          }, {})
        } else {
          acc[hmZongHe.key] = this.numList['common'].reduce((item, num) => {
            item[num.key] = get(data, `${hmZongHe.key}.${num.parentKey}.${num.key}`, 0)
            return item
          }, {})
        }
        return acc
      }, {})
    },
    gethmRowData(item) {
      const key = item.key
      const hm = item.hm
      return this.hmZongHeMappingList[hm][key]
    }
  }
}
</script>
